// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"d97e7ecd","470":"d487d3cd","568":"198d8f41","920":"a9873995","998":"53725ce1"}[chunkId] + ".chunk.js";
};